<template>
	<main>
		<div class="features-wrap features-wrapwithtop2">
			<div class="center-wrap">
				<h2>ДОСТУПНЫЕ ДЛЯ АДМИНИСТРИРОВАНИЯ ОБЪЕКТЫ</h2>
				<div class="features-list">
					<div class="features-item3">
						<router-link :to="{ name: 'AllDicts' }">
							<img :src="icons.icon1" alt="">
							<p class="features-item3__title2">СПРАВОЧНИКИ</p>
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>
<script>
    import MainSlide from '@/components/MainSlide'

    export default {
        components: {
            MainSlide,
        },
        data () {
            return {
                images: {
                    img1: require('@/assets/img/pro/rehau4.jpg'),
                },
                icons: {
                    icon1: require('@/assets/img/pro/icon-24-gr.svg'),
                    icon2: require('@/assets/img/pro/icon-21-gr.svg'),
                    icon3: require('@/assets/img/pro/icon-22-gr.svg'),
                    icon4: require('@/assets/img/pro/icon-23-gr.svg'),
                },
            }
        },
		created() {
			this.$router.push({name: 'AllDicts'})
		}
    }
</script>


<style lang="scss" scoped>
	@import "@/assets/scss/material-kit/_colors.scss";

	$mb: 80px;
	$mbt: 30px;

	/*
	main {
		padding-top: 108px;
	}
	*/
	div.center-wrap {
		max-width: 1140px;
		padding-left: 15px;
		padding-right: 15px;
		width: 100%;
		margin: 0px auto;
	}

	h2 {
		font-size: 36px;
		font-weight: 600;
		text-align: center;
	}

	.features-wrap {
		padding-bottom: 100px;
	}

	/*
	.main-screen {
		position: relative;
		display: flex;
		align-items: center;
		img {
			width: 100%;
		}

		&__block {
			position: absolute;
			right: calc( ( 100% - 1200px ) / 2 );
			background: #fff;
			padding: 35px;
			padding-right: 50px;
			h1 {
				font-size: 32px;
				font-weight: 900;
				margin-bottom: 10px !important;
				margin-top: 0px !important;
			}

			&-item {
				font-weight: 700;
				font-size: 20px;
				margin-bottom: 10px;
			}

			span {
				margin-top: 30px;
				display: block;
			}
		}
	}
	*/
	.features {

		&-wrapwithtop1 {
			margin-top: 30px;
		}

		&-wrapwithtop2 {
			margin-top: 150px;
		}

		&-wrapwithtop3 {
			margin-top: 50px;
		}

		&-wrap {
			h2 {
				margin-bottom: 30px !important;
			}
		}

		&-sub-title {
			margin-bottom: $mbt;
			font-size: 20px;
		}

		&-sub-title2 {
			margin-bottom: $mbt;
			font-size: 20px;
		}

		&-list {
			display: flex;
			justify-content: space-between;
		}

		&-grp {
			display: flex;
			justify-content: space-between;
			width: calc((100% - 60px) / 4);
			flex-direction: column;
			align-items: center;
			text-align: center;
		}

		&-list2 {
			display: flex;
			justify-content: space-between;
		}

		&-item {
			background: $green;
			width: 100%;
			padding: 30px;
			display: flex;
			flex-direction: column;
			align-items: center;
			text-align: center;

			img {
				max-width: 110px;
				margin-bottom: 30px;
			}

			&__title {
				color: #ffffff;
				text-transform: uppercase;
				font-size: 36px;
				font-weight: 500;
				line-height: 42px;
			}
		}

		&-item2 {
			width: 100%;
			padding: 10px;
			display: flex;
			flex-direction: column;
			align-items: center;
			text-align: center;

			img {
				max-width: 110px;
				margin-bottom: 30px;
			}

			&__title2 {
				color: black;
				text-transform: uppercase;
				font-weight: 700;
				font-size: 20px;
				line-height: 26px;
			}
		}

		&-item3 {
			background: $pink;
			width: calc((100% - 60px) / 4);
			padding: 30px;
			display: flex;
			flex-direction: column;
			align-items: center;
			text-align: center;
			cursor: pointer;

			img {
				max-width: 110px;
				margin-bottom: 30px;
			}

			&__title2 {
				color: #ffffff;
				text-transform: uppercase;
				font-weight: 700;
				font-size: 20px;
				line-height: 42px;
			}

			&:hover {
				position: relative;
				left: 2px;
				top: 2px;
			}

			&:active {
				position: relative;
				left: 0px;
				top: 0px;
			}
		}
	}

	/*
	@media screen and ( max-width: 1300px ) {
		.main-screen__block {
			right: 50px;
		}
	}


	@media screen and ( max-width: 1050px ) {
		.main-screen {
			&__mobile {
				width: 100%;
				padding-bottom: 53%;
				position: relative;
				img {
					position: absolute;
					top: 0px;
					left: 0px;
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}
			&__block {
				z-index: 2;
				margin-top: 50px;
			}
		}
	}
	*/

	@media screen and (max-width: 1150px) {
		.features {
			&-list {
				flex-wrap: wrap;
				margin: 0px auto;
				max-width: 800px;
			}

			&-list2 {
				flex-wrap: wrap;
				margin: 0px auto;
				max-width: 800px;
			}

			&-grp {
				width: calc(50% - 10px);
			}

			&-item {
				width: 100%;
				margin-bottom: 20px;
			}

			&-item2 {
				width: 100%;
				margin-bottom: 20px;
			}

			&-item3 {
				width: calc(50% - 10px);
				margin-bottom: 20px;
			}

			&-wrap {
				h2 {
					text-align: center;
				}

			}

			&-sub-title {
				text-align: center;
			}

			&-sub-title2 {
				text-align: center;
			}
		}
	}

	/*
	@media screen and ( max-width: 800px ) {
		.main-screen {
			&__block {
				margin-top: 20px;
				zoom: 0.85;
			}
		}

		h2 {
			font-size: 26px;
		}

		.vacancy-wrap h3 {
			font-size: 22px;
		}

	}
	*/

	@media screen and (max-width: 700px) {
		.features {
			&-list {
				flex-direction: column;
				margin: 0px auto;
				max-width: 360px;
			}

			&-list2 {
				flex-direction: column;
				margin: 0px auto;
				max-width: 360px;
			}

			&-grp {
				width: 100%;
			}

			&-item {
				width: 100%;
			}

			&-item2 {
				width: 100%;
			}

			&-item3 {
				width: 100%;
			}
		}
	}

	/*
	@media screen and ( max-width: 680px ) {
		.main-screen {
			&__block {
				margin-top: 0px;
				bottom: 20px;
			}

			&__mobile {
				img {
					width: 140%;
					left: -40%;
					max-width: 2000px !important;
				}
			}
		}
	}

	@media screen and ( max-width: 600px ) {
		.main-screen {
			&__block {
				margin-top: 0px;
				bottom: 20px;
				right: 20px;
			}

			&__mobile {
				padding-bottom: 70%;
			}
		}
	}


	@media screen and ( max-width: 480px ) {
		.main-screen {
			&__block {
				padding: 20px;
				bottom: 15px;
				right: 15px;
			}

			&__mobile {
				padding-bottom: 70%;
			}

			span {
				margin-top: 20px;
			}
		}
	}
	*/
</style>
